import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-116" data-mp="258c581r004w5">
      <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="1r9ujuaokf4he">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-118" data-mp="1r8t9k8fdim0q">
          <span aria-hidden="true" data-id="element-119" data-mp="1hj9n6ssgca14">📲 </span>What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-120" data-mp="1hh6ozlh5balb">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm font-medium text-stone-800" data-id="element-121" data-mp="1marojhye0cmm">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-122" data-mp="17j0ptbmq4ik5" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-bold italic text-red-500 sm:text-xl" data-id="element-123" data-mp="yk5g3pkh0qc3">
          You cover the entire guest journey — from booking to farewell — in
          one click.
        </p>
      </div>
    </section>;
}